type Status = 'online' | 'maintenance' | 'offline';

interface Percentage {
  online: number;
  maintenance: number;
  offline: number;
}

interface ServerCardStatusProps {
  percentage: Percentage;
  detailed?: boolean;
}

const ServerCardStatus: React.FC<ServerCardStatusProps> = ({ percentage, detailed = false }) => {
  const statusEntries: [Status, number][] = Object.entries(percentage) as [Status, number][];
  const highestStatus = statusEntries.reduce((prev, curr) => (curr[1] > prev[1] ? curr : prev))[0];

  return (
    <div className='server_card_status_container'>
      {detailed ? (
        statusEntries.map(([status, value]) => (
          <div key={status} className='server_card_status'>
            <div className={`server_card_round server_card_round_${status}`}></div>
            <p>{value}%</p>
          </div>
        ))
      ) : (
        <div className='server_card_status'>
          <div className={`server_card_round server_card_round_${highestStatus}`}></div>
          <p>{highestStatus}</p>
        </div>
      )}
    </div>
  );
};

export default ServerCardStatus;
